const NEXTJS_APP_URL = process.env.EXPO_PUBLIC_NEXTJS_APP_URL

export const ROUTES = {
  SIGNIN: NEXTJS_APP_URL ? `${NEXTJS_APP_URL}/signin` : '/public/signin',
  SIGNUP: NEXTJS_APP_URL ? `${NEXTJS_APP_URL}/auto` : '/public/auto',
  CONFIRMED: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/confirmed`
    : '/public/confirmed',
  LOGIN: '/signin',
  PRIVACY_NOTICE: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/privacy-notice`
    : '/public/privacy-notice',
  IDENTITY_NOTICE: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/identity-notice`
    : '/public/identity-notice',
  EVENTS: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/api/stub/events`
    : '/public/api/stub/events',
  SHORT_LINK: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/api/link`
    : '/public/api/link',
  RESOLVE_SHORT_LINK: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/api/short`
    : '/public/api/short',
  SEARCH_DOC: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/search-doc`
    : '/public/search-doc',
  HELP: NEXTJS_APP_URL ? `${NEXTJS_APP_URL}/help` : '/public/help',
  TOS: NEXTJS_APP_URL ? `${NEXTJS_APP_URL}/tos` : '/public/tos',
  PRIVACY_POLICY: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/privacy-policy`
    : '/public/privacy-policy',
  W_IDENTITY_PRIVACY_NOTICE: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/w-identity-privacy-notice`
    : '/public/w-identity-privacy-notice',
  IMPRINT: NEXTJS_APP_URL
    ? `${NEXTJS_APP_URL}/imprint-w-social`
    : '/public/imprint-w-social',
}
